'use client'

import moment from "moment";
import "moment/locale/ko";
import "moment/locale/en-gb";
import "moment/locale/zh-cn";
import { useLocale } from "next-intl";
// 언어코드 수정
type formatTypes = 
    "MMM DD (ddd) HH:mm"     
    | "YYYY-MM-DD HH:mm:ss" 
    | "YYYY-MM-DD HH:mm" 
    | "YYYY-MM-DD" 
    | "HH:mm" 
    | "MM-DD" 
    | "MM-DD HH:mm"
export default function LocaleFormat({ date, format }: { date: string | Date, format: formatTypes }) {
    const locale = useLocale();
    const special_format = ["ko", "zh"]

    switch (format) {
        case "MMM DD (ddd) HH:mm":
            return (
                moment(date)
                    .locale(special_format.includes(locale) ? locale : "en")
                    .format(
                        // 한국어
                        locale === 'ko' ? 'MM월DD일(ddd) HH:mm'
                            // 쭝
                            : locale === 'zh' ? "MM月DD日 (ddd) HH:mm"
                                // 그외
                                : "MMM DD (ddd) HH:mm"
                    )
            )
            break;
        case "YYYY-MM-DD HH:mm:ss":
        case "YYYY-MM-DD HH:mm":
        case "YYYY-MM-DD":
        case "HH:mm":
            return moment(date).format(format)
            break;
        case "MM-DD":
            return (
                moment(date)
                    .locale(special_format.includes(locale) ? locale : "en")
                    .format(
                        // 한국어
                        locale === 'ko' ? 'MM-DD'
                            // 쭝
                            : locale === 'zh' ? "MM月DD日"
                                // 그외
                                : "MMM DD"
                    )
            )
            break;
        case "MM-DD HH:mm":
            return (
                moment(date)
                    .locale(special_format.includes(locale) ? locale : "en")
                    .format(
                        // 한국어
                        locale === 'ko' ? 'MM-DD HH:mm'
                            // 쭝
                            : locale === 'zh' ? "MM月DD日 HH:mm"
                                // 그외
                                : "MMM DD HH:mm"
                    )
            )
            break;
    }

}